import { getGoalsCascadedViewApi, getGoalsTreeViewApi } from '../api';

export const getGoalsCascadedView = async ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  isHierarchyView,
  pageType,
  isTreeView = false,
  mergeColumns = false,
  ownership,
}) => {
  try {
    const res = await getGoalsCascadedViewApi({
      cohort,
      groupByKeys,
      splitByKeys,
      orderBy,
      timeBounds,
      attributeFilter,
      isHierarchyView,
      pageType,
      isTreeView,
      mergeColumns,
      ownership,
    });
    return res.entity;
  } catch (err) {
    console.error('Error fetching goals cascaded view data : ', err);
  }
};

export const getGoalsTreeView = async ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  pageType,
  ownership,
}) => {
  try {
    const res = await getGoalsTreeViewApi({
      cohort,
      groupByKeys,
      splitByKeys,
      orderBy,
      timeBounds,
      attributeFilter,
      pageType,
      ownership,
    });
    return res.entity;
  } catch (err) {
    console.error('Error fetching goals tree view data : ', err);
  }
};
